module.exports = new __parcel__URL__("Klug.f5d1488e.webp").toString();